import { AssetApiResponse, AssetDetails } from '../../app/modules/types/asset'
import type { BulkOwnerBody, BulkResponse } from '../../app/modules/types/issues'
import { apiClient } from '../client'
import { OWNS_ERRORS } from '../ownsErrors'

/**
 * Assets API endpoints
 */
export const assetsApi = {
  /**
   * Set (or clear, with `owner: null`) the owner of many assets at once. The
   * dialog renders its own refusals, so the request opts out of the global handling.
   */
  bulkOwner: async (body: BulkOwnerBody): Promise<BulkResponse> => {
    const { data } = await apiClient.post('/assets/bulk-owner/', body, OWNS_ERRORS)
    return data
  },

  /**
   * Get assets list
   */
  getList: async (params?: string): Promise<AssetApiResponse> => {
    const url = params ? `/assets/?${params}` : '/assets/'
    const { data } = await apiClient.get(url)
    return data
  },

  /**
   * Get asset by ID
   */
  getById: async (assetId: string, customScanIds?: string): Promise<AssetDetails> => {
    const url = customScanIds
      ? `/assets/${assetId}/?custom_scan_ids=${customScanIds}`
      : `/assets/${assetId}/`
    const { data } = await apiClient.get(url)
    return data
  },

  /**
   * Get asset statistics
   */
  getStats: async (): Promise<any> => {
    const { data } = await apiClient.get('/assets/stats/')
    return data
  },

  /**
   * Get asset filter options
   */
  getFilterOptions: async (): Promise<any> => {
    const { data } = await apiClient.get('/assets/filter/')
    return data
  },
}
